import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
/**
 *
 * Util function to be used with the Editor to track the EditorActions prop
 *
 * @param editorActions
 * @param performanceTracking
 * @param handleAnalyticsEvent
 * @returns
 */
export default function trackEditorActions(editorActions, performanceTracking, handleAnalyticsEvent) {
  var _performanceTracking$;
  if (performanceTracking !== null && performanceTracking !== void 0 && (_performanceTracking$ = performanceTracking.contentRetrievalTracking) !== null && _performanceTracking$ !== void 0 && _performanceTracking$.enabled) {
    var DEFAULT_SAMPLING_RATE = 100;
    var getValue = editorActions.getValue.bind(editorActions);
    if (!editorActions._contentRetrievalTracking) {
      editorActions._contentRetrievalTracking = {
        samplingCounters: {
          success: 1,
          failure: 1
        },
        getValueTracked: false
      };
    }
    var _editorActions$_conte = editorActions._contentRetrievalTracking,
      samplingCounters = _editorActions$_conte.samplingCounters,
      getValueTracked = _editorActions$_conte.getValueTracked;
    if (!getValueTracked) {
      var getValueWithTracking = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _performanceTracking$2, _performanceTracking$3, value, _performanceTracking$4, _performanceTracking$5, _performanceTracking$6;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getValue();
              case 3:
                value = _context.sent;
                if (samplingCounters.success === ((_performanceTracking$2 = performanceTracking === null || performanceTracking === void 0 || (_performanceTracking$3 = performanceTracking.contentRetrievalTracking) === null || _performanceTracking$3 === void 0 ? void 0 : _performanceTracking$3.successSamplingRate) !== null && _performanceTracking$2 !== void 0 ? _performanceTracking$2 : DEFAULT_SAMPLING_RATE)) {
                  handleAnalyticsEvent({
                    payload: {
                      action: ACTION.EDITOR_CONTENT_RETRIEVAL_PERFORMED,
                      actionSubject: ACTION_SUBJECT.EDITOR,
                      attributes: {
                        success: true
                      },
                      eventType: EVENT_TYPE.OPERATIONAL
                    }
                  });
                  samplingCounters.success = 0;
                }
                samplingCounters.success++;
                return _context.abrupt("return", value);
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                if (samplingCounters.failure === ((_performanceTracking$4 = performanceTracking === null || performanceTracking === void 0 || (_performanceTracking$5 = performanceTracking.contentRetrievalTracking) === null || _performanceTracking$5 === void 0 ? void 0 : _performanceTracking$5.failureSamplingRate) !== null && _performanceTracking$4 !== void 0 ? _performanceTracking$4 : DEFAULT_SAMPLING_RATE)) {
                  handleAnalyticsEvent({
                    payload: {
                      action: ACTION.EDITOR_CONTENT_RETRIEVAL_PERFORMED,
                      actionSubject: ACTION_SUBJECT.EDITOR,
                      attributes: {
                        success: false,
                        errorInfo: _context.t0.toString(),
                        errorStack: performanceTracking !== null && performanceTracking !== void 0 && (_performanceTracking$6 = performanceTracking.contentRetrievalTracking) !== null && _performanceTracking$6 !== void 0 && _performanceTracking$6.reportErrorStack ? _context.t0.stack : undefined
                      },
                      eventType: EVENT_TYPE.OPERATIONAL
                    }
                  });
                  samplingCounters.failure = 0;
                }
                samplingCounters.failure++;
                throw _context.t0;
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 9]]);
        }));
        return function getValueWithTracking() {
          return _ref.apply(this, arguments);
        };
      }();
      editorActions.getValue = getValueWithTracking;
      editorActions._contentRetrievalTracking.getValueTracked = true;
    }
  }
  return editorActions;
}